// Import Link component
import { Link, Outlet } from "react-router-dom";

// ! The Outlet component tells React Router where to render the child route components!!!

import React from "react";

function Layout() {
  return (
    <>
      <main>
        <Outlet />
      </main>
      <footer className="left-0 bottom-0 fixed w-full">
        <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 bg-green-500">
          <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
            <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
              <Link
                to="/"
                className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-black"
              >
                FIT-TRACK
              </Link>
              <Link
                to="/GetStarted"
                className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
              >
                Get Started
              </Link>
              <Link
                to="/exercises"
                className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
              >
                Workout List
              </Link>
            </div>
          </div>
        </nav>
      </footer>
    </>
  );
}

export default Layout;
